'use client'

import { useSession } from '@/lib/session-client'
import { ComponentType, JSX, ReactElement, useMemo } from 'react'
import { AdminButton } from './AdminButton'
import { useAdminData } from './useAdminData'
import { clientPOST } from '@/api/client'
import { AdminButtonType } from '@/types'
import Button from '../ui-other/basic/Button'
import { formattedDateTimeShort } from '@/shared/timeHelper'

interface Props {
  tournamentId?: string
  teamId?: string
  clubId?: string
  gameId?: string
}

export const AdminBarWrapper: ComponentType<Props> = (
  props
): ReactElement | null => {
  const { session, isAdmin } = useSession()
  if (!session || !isAdmin) {
    return null
  }
  return <AdminBar {...props} />
}

const AdminBar: ComponentType<Props> = ({
  tournamentId,
  teamId,
  clubId,
  gameId
}): ReactElement | null => {
  const { session, isAdmin } = useSession()
  if (!session || !isAdmin) {
    return null
  }
  const adminData = useAdminData(
    session.accessToken,
    tournamentId,
    teamId,
    clubId,
    gameId
  )

  // TODO: map does not seem to work here
  const infos = useMemo(() => {
    if (adminData && adminData.infos && adminData.infos.length > 0) {
      const result: JSX.Element[] = []
      adminData.infos.forEach((i) => {
        if (i.values && i.values.length > 0) {
          result.push(
            <div>
              <p>{i.name}</p>
              {i.values.map(({ key, value }) => {
                return (
                  <p>
                    {key}: {formattedDateTimeShort(value)}
                  </p>
                )
              })}
            </div>
          )
        }
      })
      return <>{...result}</>
    }
  }, [adminData])
  const buttons = useMemo(() => {
    if (adminData && adminData.buttons && adminData.buttons.length > 0) {
      const result: JSX.Element[] = []
      adminData.buttons.forEach((b) => {
        if (b.type == AdminButtonType.LINK) {
          result.push(
            <div className="py-4 border-b border-gray-200">
              <div>{b.tooltip}:</div>
              <div>
                <Button small link className="h-auto">
                  <a
                    className="btn btn-primary btn-sm h-full"
                    href={`/a${b.url}&access_token=${session.accessToken}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {b.title}
                  </a>
                </Button>
              </div>
            </div>
          )
        } else {
          result.push(
            <div className="py-4 border-b border-gray-200">
              <div>{b.tooltip}:</div>
              <div>
                <AdminButton
                  title={b.title}
                  callback={() => {
                    clientPOST({
                      url: b.url,
                      data: {}
                    })
                  }}
                />
              </div>
            </div>
          )
        }
      })
      return <>{...result}</>
    }
  }, [adminData])
  if (!adminData || (!infos && !buttons)) {
    return null
  }
  return (
    <>
      <div className="flex space-x-2 mb-4 pb-4 border-b border-gray-200">
        {infos}
      </div>
      <div className="mb-4">{buttons}</div>
    </>
  )
}
